import { AppState } from '../app.state';

export const getFighterImage = (imagePath: string) => (state: AppState) => {
  const result = state.image.fighterImages[imagePath];

  return result;
};

export const getFighterImageLoading = (state: AppState): boolean =>
  state.image.isLoading;

export const getFighterImageIndividualLoading =
  (imagePath: string) => (state: AppState) => {
    return state.image.loadingImages[imagePath] || false;
  };

export const getFighterImageError = (state: AppState): string | null =>
  state.image.error;
